module.exports = __webpack_public_path__ + "media/photo/AdobeStock_313373132-8fa0724f.png";